"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchFilter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _search = _interopRequireDefault(require("@ux/search"));
var _button = _interopRequireDefault(require("@ux/button"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _core = require("@linaria/core");
/* eslint-disable max-len */

/**
 * Local Imports
 */

const Nav = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Nav",
  class: "pl-nhl8gu2"
});
const search = "pl-s1wdv05t";

/**
 * SearchFilter Component.
 *
 * @param {Object} props React props
 * @param {Array} props.data Array of Search Data
 * @param {String} props.value Key Value On Change
 * @param {Function} props.onChange Forwarded Function
 * @param {String} props.placeholder Search PlaceHolder
 * @returns {React.ReactElement} SearchFilter Component
 * @public
 */

function SearchFilter({
  data,
  value,
  onChange,
  placeholder = 'Search by role or keyword',
  ...rest
}) {
  const searchIcon = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "search"
  });
  const button = /*#__PURE__*/_react.default.createElement(_button.default, {
    design: "inline",
    icon: searchIcon,
    active: false
  });
  return /*#__PURE__*/_react.default.createElement(Nav, {
    "data-cy": "search-filter"
  }, /*#__PURE__*/_react.default.createElement(_search.default, (0, _extends2.default)({}, rest, {
    id: "job-search",
    className: search,
    data: data,
    value: value,
    onChange: onChange,
    clearable: false,
    placeholder: placeholder,
    button: button
  })));
}
SearchFilter.propTypes = {
  data: _propTypes.default.array.isRequired,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  ..._search.default.propTypes
};